import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { AppProvider } from './components/context/AppContext';
import Home from './pages/Home';
import Promo from './pages/Promo'
import Bestseller from './pages/Bestseller';
import Help from './pages/Help';
import Contact from './pages/Contact';
import DetailProduk from './pages/DetailProduk';
import './styles/main.scss';

function App() {
  return (
    <AppProvider >
      <div className="App">
        <Router>
          <Switch>
            <Route path='/' exact component={Home} />
            <Route path='/promo' exact component={Promo} />
            <Route path='/bestseller' exact component={Bestseller} />
            <Route path='/help' exact component={Help} />
            <Route path='/contact' exact component={Contact} />
            <Route path='/detail-produk' exact component={DetailProduk} />
          </Switch>
        </Router>
      </div>
    </AppProvider>
  );
}

export default App;
